const STORAGE_KEY = "chat-app-user";

export function getApiBase() {
  return (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");
}

/**
 * URL del API. En desarrollo usa ruta relativa (proxy de `npm start` → puerto 5050).
 * En producción usa REACT_APP_API_URL.
 */
export function apiUrl(path) {
  const p = path.startsWith("/") ? path : `/${path}`;
  if (process.env.NODE_ENV === "development") {
    return p;
  }
  const base = getApiBase();
  return base ? `${base}${p}` : p;
}

/** fetch al API; en producción reintenta URL absoluta si la relativa devuelve 404. */
export async function fetchApi(path, init = {}) {
  const relative = apiUrl(path);
  const base = getApiBase();
  const normalized = path.startsWith("/") ? path : `/${path}`;
  const absolute = base ? `${base}${normalized}` : null;

  let res = await fetch(relative, init);
  if (
    res.status === 404 &&
    absolute &&
    relative !== absolute &&
    process.env.NODE_ENV !== "development"
  ) {
    res = await fetch(absolute, init);
  }
  return res;
}

export function getStoredUser() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function getAuthToken() {
  const u = getStoredUser();
  return u && u.token ? u.token : null;
}

export function authHeaders() {
  const token = getAuthToken();
  const h = { "Content-Type": "application/json" };
  if (token) {
    h.Authorization = `Bearer ${token}`;
  }
  return h;
}

/** Cuenta con invitación blog (admin o editor): mismo acceso al panel y API del blog. */
export function isBlogStaff() {
  const u = getStoredUser();
  const r = String(u?.role || "").trim().toLowerCase();
  return r === "admin" || r === "editor";
}

/** Solo invitación `BLOG_ADMIN_INVITE_CODE` (enlaces “Editar post” en el blog público). */
export function isBlogAdmin() {
  const u = getStoredUser();
  return String(u?.role || "").trim().toLowerCase() === "admin";
}

/** @deprecated usar isBlogStaff; se mantiene por compatibilidad con imports existentes */
export function isBlogEditor() {
  return isBlogStaff();
}

export function isLoggedIn() {
  return Boolean(getStoredUser());
}

/** Ruta principal tras login. Las reservas ahora se gestionan por WhatsApp. */
export function getDashboardPath() {
  return "/";
}

/** Nombre para UI: `name` del perfil o parte local del email. */
export function getUserDisplayName() {
  const u = getStoredUser();
  if (!u) return "";
  const n = typeof u.name === "string" ? u.name.trim() : "";
  if (n) return n;
  const email = typeof u.email === "string" ? u.email.trim() : "";
  if (email) return email.split("@")[0] || email;
  return "Usuario";
}

/** Primera letra del nombre para avatar en UI. */
export function getUserInitial() {
  const d = getUserDisplayName();
  const letter = d.charAt(0).toUpperCase();
  return letter || "?";
}

export function logout() {
  localStorage.removeItem(STORAGE_KEY);
}
